import useRestaurantMapsWithTables from "@/shared/queries/restaurantMap/useRestaurantWithTables";
import { orderStatussesInterface } from "@/shared/utils/constant";
import { OrderStatus } from "@/shared/utils/enum";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import { useEffect, useMemo, useState } from "react";
import MapsMenu from "../../Maps/MapsMenu";
import LiveLanes from "./LiveLanes";

export const orderStatusses: orderStatussesInterface[] = [
  {
    label: "Nieuw",
    value: [OrderStatus.ARRIVED, OrderStatus.CONFIRMED],
    id: "confirmed",
    translationKey: "new",
  },
  {
    label: "Keuken",
    value: [
      OrderStatus.IN_KITCHEN,
      OrderStatus.READY_FOR_PACKAGING,
      OrderStatus.READY_FOR_DELIVERY,
    ],
    id: "in_kitchen",
    translationKey: "kitchen",
  },

  {
    label: "Afgeleverd",
    value: [OrderStatus.HANDED_OVER, OrderStatus.EN_ROUTE],
    id: "handed_over",
    translationKey: "handed_over",
  },
];

const LiveMap = ({ data }: { data: OrdersLive }) => {
  const { data: maps } = useRestaurantMapsWithTables();
  const usedTableNumbers = useMemo(() => {
    return (
      data?.flat()?.map((order) => order?.order_information?.table_number) ?? []
    );
  }, [data]);

  const tables = useMemo(() => {
    return (
      maps?.flatMap((map) =>
        map.tables.filter((t) => usedTableNumbers.includes(t.table_number))
      ) ?? []
    );
  }, [maps, usedTableNumbers]);

  const [table, setTable] = useState(undefined);

  const orders = useMemo(() => {
    return data.map((day) =>
      day.filter((order) => order?.order_information?.table_number === table)
    );
  }, [data, table]);

  useEffect(() => {
    if (tables) {
      setTable(tables?.[0]?.table_number);
    }
  }, [tables]);

  return (
    <div className="flex gap-4">
      <div className="flex h-full w-full flex-col md:w-1/4">
        <MapsMenu
          showMapChose={false}
          table={table}
          setTable={setTable}
          editable={false}
          tablePropertyName="table_number"
          tables={tables}
        />
      </div>
      <div className="w-3/4">
        <LiveLanes customLanes={orderStatusses} data={orders} />
      </div>
    </div>
  );
};

export default LiveMap;
